<template>
    <div v-if="display" class="AgencyInfos-container" @click.self="closeModal">
        
        <!-- Agency eligible -->
        <div v-if="agency.name" class="AgencyInfos-content">
            <div class="Modal-close" @click="closeModal">
                <svg v-svg symbol="Close" size="0 0 16 16" role="presentation" class="icon--inline icon-Close"></svg>
            </div>
    
            <!-- Angency Infos -->
            <div class="AgencyInfos-success">
              <span>Vous êtes éligible à notre agence</span>
              
                <!-- Address -->
                <div class="Modal-agency agencyAdress">
                    <div>
                        <svg
                            v-svg
                            symbol="Map"
                            size="0 0 12 12"
                            role="presentation"
                            class="icon--inline Icon-Map"
                        ></svg>
                    </div>

                    <div>
                        <p class="greenText">{{ agency.name }}</p>
                        <p>{{ agency.address }}</p>
                        <p>{{ agency.zipcode }} {{ agency.city }}</p>
                    </div>  
                </div>

                <!-- Phone 
                <div class="Modal-agency agencyPhone">
                    <div>
                        <svg
                            v-svg
                            symbol="Phone"
                            size="0 0 12 12"
                            role="presentation"
                            class="icon--inline Icon-Phone"
                        ></svg>
                    </div>

                    <div>
                        <p>{{ agency.telephone }}</p>
                    </div>  
                </div>-->

                <div class="Modal-eligibilityLogos">
                    <img :src="baseUrl + '/media/' + agency.logo" alt="agency logo" />
                </div>
            </div>

            <!-- Call To Action -->
            <div class="cta-content" :inner-html.prop="cta"></div>
            
        </div>

        <!-- No agency eligible -->
        <div v-else>       
            <Messages
                :text="noAgencyMessage"
                :type="'danger'"
            ></Messages>
        </div>

        
    </div>
</template>

<script>
import Messages from "@/components/Messages/Messages.vue";

export default {

    name: "ModalEligibleAgency",

     props: {
        display: {
            type: Boolean,
            default: false
        },
        agency: {
            type: Object,
            default: {}
        },
        noAgencyMessage: {
            type: String,
            default:""
        },
        cta: {
            type: Object,
            default: "",
        }
    },
    
    components: { Messages },

    data() {
        return {
            baseUrl: process.env.VUE_APP_API_BASE_URL,
        };
    },

    methods: {
        closeModal() {
            this.$emit('hideAgencyInfos');
        },
    },
    
}
</script>

<style lang="scss">
.AgencyInfos-container {
    position: fixed;
    top: 0;
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, .6);

    @media ($mq-phone) {
        align-items: flex-end;
    }

    .AgencyInfos-content {
        position: relative;
        padding: 20px;
        background: $color-white;

        @media ($mq-from-tablet) {
            padding: 50px;
        }

        @media ($mq-phone) {
            max-height: 85%;
        }

        @media ($mq-desktop) {
            display: flex;
        }

        .Modal-close {
            position: absolute;
            top: 15px;
            right: 15px;

            &:hover {
                cursor: pointer;
            }

            @media ($mq-phone) {
                top: 5px;
                right: 5px; 
            }
            

            .icon-Close {
                background-image: url(../../assets/icons/zeborne/Close.svg);
                background-repeat: no-repeat;
                background-position: 50%;
            }
        }

        .AgencyInfos-success,
        .cta-content {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 20px;
            margin: 10px;
        }

        /* Angency found Infos */
        .AgencyInfos-success{
            background-color: rgba(67,195,77,.06);
            border-radius: 7px;

            .Modal-agency {
                display: flex;
                font-weight: 600;
                margin: 10px 0;

                .icon--inline {
                   margin-right: 10px; 
                }
            }

            .Modal-agency .Icon-Map {
                fill: $color-green;
            }

            .Modal-agency .Icon-Phone{
                transform: rotate(90deg);   
            }

            .Modal-eligibilityLogos img {
                max-width: 200px;
                margin-right: 5px;

                @media ($mq-desktop) {
                   max-width: 300px;
                }
            }
        }

        .AgencyInfos-image {
            padding: 20px;
            margin: 10px;
            border-radius: 7px;
        }

        .cta-content{

            @media ($mq-phone) {
                padding: 0;
            }

            .submenu-cta-block {
                margin: 20px 0;

                .content {
                    @media ($mq-from-tablet) {
                       display: flex;
                        align-items: center; 
                    }  
                }
                
                a:hover{
                    h5,
                    p.text strong{
                        color: $color-red;
                    }
                }
            }

            .picture {
                width: 32px;
                margin-right: 20px;
            }

            .cta-push-marketing{
                display: none;
            }
        }
    }

    .greenText {
        color: $color-green;
    }
}

</style>